<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
      
    <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
      	<el-form-item>
            <el-date-picker	v-model="query.date" type="daterange" style="width:100%"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-select v-model="query.type" placeholder="审核状态" clearable @change="query.ischange=true">
                <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item ref="query.key" :model="query">
            <el-input placeholder="请输入订单号 / 客户名称 / 收货人姓名 / 收货人电话" v-model="query.key" clearable @change="query.ischange=true" @keyup.enter.native="getorderlists"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="getorderlists">搜索</el-button>
        </el-form-item>
        <el-form-item>
            <el-badge :value="delgoodslists.length > 0 ? delgoodslists.length : ''" class="item">
            <el-dropdown @command="handleordermore">
                <el-button size="small" type="warning">批处理订单</el-button>
                <el-dropdown-menu slot="dropdown">							
                    <el-dropdown-item  command="1" key="1" @click="verifyordermore" >批量审核订单</el-dropdown-item>
                    <el-dropdown-item  command="2" key="2" >批量反审核订单</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            </el-badge>
			  </el-form-item>
			  <el-form-item>
            <el-badge :value="delgoodslists.length > 0 ? delgoodslists.length : ''" class="item">
            <el-button type="" size="small" round @click="clearorderselect">清空已选中订单</el-button>
            </el-badge>
			  </el-form-item>
	  </el-form>
    <div class="cz-mall-order-verifys"><i></i><span>温馨提示：特批单为宠赞跑店小程序里，业务员代替商家所下的未支付的线上商城订单，宠赞管理员可对订单进行审核，然后知会门店商家进行付款（注：如果该订单门店已付款则不允许再审核或进行反审核）</span></div>
      
	  
	  <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" style="width:100%" v-loading="query.loading" ref="goodsmultipleTable" @select="goodsselectchange" @select-all="goodsallselectchange">
				<el-table-column type="expand">
				<template slot-scope="props">
				    <div class="cz-mall-order-addressinfo">	
                <span style="float:left;width:100%;font-size:13px;line-height:21px;">订单备注：{{props.row.note}}</span><br/>
                <span style="float:left;width:100%;font-size:13px;line-height:21px;">
                    收货人信息：{{props.row.truename}}，{{props.row.phone}}，
                    {{props.row.province}} 
                    {{props.row.city=='' ? '' : '-'+props.row.city}}
                    {{props.row.town=='' ? '' : '-'+props.row.town}}
                    {{props.row.country=='' ? '' : '-'+props.row.country}}
                    {{props.row.address=='' ? '' : '，'+props.row.address}}
                </span>						
			      </div>
	          <el-table :data="props.row.goods">
                <el-table-column label="id" min-width="130" align="center">
                    <template slot-scope="goods">
                        <div style="float:left;width:100%">{{goods.row.id}}</div>
                        <div style="float:left;width:100%;font-size:12px;color:#909399">（sku：{{goods.row.sku}}）</div>
                    </template>
                </el-table-column>
		            <el-table-column label="商品名称" min-width="320">
		                <template slot-scope="goods">
							<div style="float:left;width:65px;height:65px;position:relative;">
								<div class="cz-mall-order-goods-infos">
									<img :src="goods.row.thumb=='' ? require('../../assets/default_img_mini.png') : goods.row.thumb"  class="mall-order-info-goods-thumb"/>
								</div>
								<i class="cz-mall-order-goods-jd-icon" v-if="goods.row.type==2">JD</i>
								<i class="cz-mall-order-goods-song" v-if="goods.row.isgift==1">送</i>
							</div>
                            <div style="float:left;width:calc(100% - 65px - 2px - 5px);min-height:65px;margin-left:5px;">
								<span class="cz-mall-order-goods-name">
                                    {{goods.row.brandname ? '【'+goods.row.brandname+'】' : ''}}
                                    {{goods.row.productname}}
                                    {{goods.row.propertyname ? ' [ '+goods.row.propertyname+' ] ' : ''}}
                                </span>
								<span class="cz-mall-order-goods-active-detail" v-if="goods.row.active && goods.row.active!=''">{{goods.row.active}}</span>
								<span class="cz-mall-order-goods-active-news" v-if="goods.row.offersnew && goods.row.offersnew!=''">{{goods.row.offersnew}}</span>
								<span class="cz-mall-order-goods-active-change" v-if="goods.row.offerschange && goods.row.offerschange!=''">{{goods.row.offerschange}}</span>
                            </div>
                        </template>
		            </el-table-column>
                    <el-table-column prop="baseprice" label="原价" min-width="120" align="center"></el-table-column>
                    <el-table-column prop="numbers" label="折扣" min-width="120" align="center">
                        <template slot-scope="props">
                            <div style="float:left;width:100%;font-size:14px;line-height:23px">{{props.row.discount}}%</div>
                        </template>
					</el-table-column>
                    <el-table-column prop="price" label="售价" min-width="120" align="center"></el-table-column>
		            <el-table-column prop="numbers" label="数量" min-width="120" align="center">
                        <template slot-scope="props">
                            <div style="float:left;width:100%;font-size:14px;line-height:23px">{{props.row.numbers}}</div>
                        </template>
					</el-table-column>
		            <el-table-column prop="basetotal" label="小计" min-width="120" align="center"></el-table-column>
					<el-table-column prop="derate" label="优惠" min-width="120" align="center"></el-table-column>
					<el-table-column prop="total" label="实际小计" min-width="120" align="center"></el-table-column>
	              </el-table>
	          </template>
				    </el-table-column>

				    <el-table-column type="selection" width="50" align="center"></el-table-column>
				    <el-table-column label="id" align="center" min-width="100">
                        <template slot-scope="props">
                            <div style="display:inline-block;width:100%;text-align:center;font-size:13px">{{props.row.id}}</div>
                        </template>
				    </el-table-column>
                    <el-table-column label="订单信息" min-width="250">
                        <template slot-scope="props">
                            <span class="cz-mall-order-number">{{props.row.ordernumber}}
                                <a class="cz-mall-order-yh" @click="showactives(props.row.active)" v-if="props.row.active!=''">惠</a>
                            </span>

                            <!-- 拼团活动 -->
                            <el-tooltip class="item" effect="dark" :content="props.row.orderactives.msg" placement="top" v-if="props.row.orderactives.msg!=''">
                                <span class="cz-mall-order-pt">{{props.row.orderactives.name}}</span>
                            </el-tooltip>				
                            <span class="cz-mall-order-shop"><a @click="getshopinfos(props.row.shopid)">店铺名称：{{props.row.shopname}}</a></span>
                            <span class="cz-mall-order-seller">跑店销售员：{{props.row.clerkname}}</span>
                        </template>
                    </el-table-column>	
				    <el-table-column label="订单金额" prop="total" min-width="100" align="center"/>
				    <el-table-column label="优惠减免" prop="derate" min-width="100" align="center"/>
				    <el-table-column label="额外优惠" prop="derateprice" min-width="100" align="center"/>
				    <el-table-column label="额外运费" prop="express" min-width="100" align="center"/>
				    <el-table-column label="实付金额" prop="allprice" min-width="140" align="center">
                <template slot-scope="props">
                    <div style="float:left;width:100%;font-size:14px;line-height:23px">{{props.row.allprice}}</div>
                </template>
				    </el-table-column>
            <el-table-column label="下单时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <span class="cz-mall-order-inputtime">{{scope.row.inputtime}}</span>
                </template>
            </el-table-column>
            <el-table-column label="审核人" min-width="150" align="center">
                <template slot-scope="scope">
                    
                    <div class="cz-mall-order-inputtime cz-mall-order-inputtime-center"><span>{{scope.row.especially_veriyer}}</span></div>
                    <div class="cz-mall-order-inputtime cz-mall-order-inputtime-center" v-if="scope.row.especially_status==0"><span>待审核</span></div>
                    <div class="cz-mall-order-inputtime cz-mall-order-inputtime-center" v-if="scope.row.especially_status==1"><span>审核成功</span></div>
                    <div class="cz-mall-order-inputtime cz-mall-order-inputtime-center" style="display:flex;justify-content:center;align-items:center" v-if="scope.row.especially_status==2">
                        <span>审核失败</span>
                        <el-tooltip class="item" effect="dark" :content="scope.row.especially_reason" placement="top">
                            <i></i>
                        </el-tooltip>
                    </div>
                    <div class="cz-mall-order-inputtime cz-mall-order-inputtime-center"><span>{{scope.row.especially_time}}</span></div>
                    <div v-if="scope.row.status == 9 || scope.row.status == 10">(订单已取消)</div>
                </template>
            </el-table-column>	
            
            <el-table-column label="操作" min-width="90" align="center">
                <template slot-scope="props">					
                    <el-dropdown>
                        <el-button type="warning" size="mini" icon="el-icon-arrow-down" circle></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="gotoverify(props.row)">去审核</el-dropdown-item>
                            <el-dropdown-item @click.native="cannelverify(props.row)">反审订单</el-dropdown-item>
                            <el-dropdown-item @click.native="checklogs(props.row)">查看日志</el-dropdown-item>
                            <el-dropdown-item v-if="props.row.paytype != 9 && (props.row.status==0 || props.row.status==4)" @click.native="cannelGoods(props.row)">取消订单</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
		        <el-pagination 
		            @size-change="orderpageSizeChange" 
		          	@current-change="orderpageCurrentChange"
		          	:current-page="query.p"
		          	:page-sizes="[10, 20, 50]"
		          	:page-size="query.rollpage"
		          	layout="total, sizes, prev, pager, next, jumper"
		          	:total="query.rows">
		        </el-pagination>
	   		</div>
    </div>


	  <!-- 批量审核订单信息 -->
    <el-dialog :title="verifyorders.title" :visible.sync="verifyDialog" width="25%">
        <div class="cz-mall-order-ready-title">待处理的订单<i>（共 {{temporderlists.length}} 单）</i></div>
        <div class="cz-mall-order-ready-content">
            <div class="cz-mall-order-ready-infos" @click="deltemporders(index)" v-for="(item,index) in temporderlists" :key="index">{{item.ordernumber}}<a></a></div>
        </div>

        <div class="cz-mall-order-ready-handle">
            <div class="cz-mall-order-ready-handle-title">审核意见</div>
            <div class="cz-mall-order-ready-handle-content">
                <el-select v-model="verifyorders.status" placeholder="审核状态" size="small" @change="query.ischange=true">
                    <el-option v-for="(item,index) in verifystatuslists" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
            </div>
        </div>
        <div class="cz-mall-order-ready-handle" v-if="verifyorders.status==2" style="margin-top:10px">
            <el-input type="textarea" v-model="verifyorders.reason" placeholder="请填写审核失败原因" :autosize="{ minRows: 5, maxRows: 10}" />
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="verifyDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="verifyorders.loading" @click="saveverifyer">确 认</el-button>
        </div>
    </el-dialog>

    
    <!-- 错误信息查看集群 -->
    <el-dialog title="批量操作结果" :visible.sync="errorshowDialog" width="40%" top="10vh">
        <div class="mall-order-refund-msg-more-result-out-verify">
            <div class="mall-order-refund-msg-more-result-verify" v-for="(item,index) in errorshow" :key="index">
                <img src="../../assets/error.png" />
                <div class="mall-order-refund-msg-more-result-content-verify">{{item}}</div>
            </div>
        </div>
    </el-dialog>


    <!-- 操作记录 -->
    <el-dialog title="操作日志" :visible.sync="logDialog" width="40%" top="5vh">
        <div class="mall-order-sale-after-log-out-verify" v-loading="logloading">
            <div v-for="(item,index) in loginfos" v-if="loginfos.length > 0" :key="index" class="mall-order-sale-after-log-in-verify" :style="index==0 ? 'color:red;border-left:1px solid red' : ''">
                <div class="mall-order-sale-after-log-in-label-verify" :style="index==0 ? 'background:red' : ''">
                    <div class="mall-order-sale-after-log-in-label-in-verify" :style="index==0 ? 'background:red' : ''"></div>
                </div>
                <div class="mall-order-sale-after-log-in-msg-verify">{{item.name}}（{{item.description}}）</div>
                <div class="mall-order-sale-after-log-in-msg-verify">{{item.inputtime}}</div>
            </div>
            <div v-if="loginfos.length == 0"  style="display:flex;width:100%;height:100px;justify-content:center;align-items:center;">
                <img src="../../assets/history_gray.png" style="width:30px;height:30px;display:inline-block" />
                <div style="font-size:14px;margin-left:2%;color:#777777">暂无操作记录</div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="logDialog = false">取 消</el-button>
        </div> 
    </el-dialog>

    <!-------------------------------------- 取消订单 -------------------------------------------->
    <el-dialog title="取消订单" :visible.sync="cannelDialog" width="20%" top="15vh">
        <el-form>
            <el-col :span="24">
                <el-input size="small" type="textarea" :autosize="{minRows:6, maxRows:10}" placeholder="请填写取消订单原因" v-model="reason"></el-input>
            </el-col>
        </el-form>
        <el-col :span="24" style="margin-top:20px"></el-col>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cannelDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="cannelLoading" @click="cannelSave">确 认</el-button>
        </div>
    </el-dialog>

           
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
        url:this.GLOBAL.domain+"Order/index",
        transitionshow:true,
        actionauth:'', //功能权限
        query: {
            act: 'getverifyorderlists',
            token: this.$cookies.get('token'),
            date: [],
            type:1,
				    key:'',
            loading:false,
            ischange:false,
            p:1,
            rollpage:10,
            rows:0,
        },
        lists:[],
        typelists:[{id:1,name:'未审核'},{id:2,name:'审核成功'},{id:3,name:'审核失败'},{id:4,name:'已取消'}],
        delgoodslists:[],
        temporderlists:[],
        verifyDialog:false,
        verifyorders: {
            act:'verifymoreorder',
            token:this.$cookies.get('token'),
            ids:[],
            reason:'',
            status:1,
            title:'',
            titletype:1,
            type:'',
            loading:false,
        },
        verifystatuslists:[{id:1,name:'审核通过'},{id:2,name:'审核失败'}],
        errorshowDialog:false,
        errorshow:[],
        
        logDialog:false,
        logloading:false,
        loginfos:[],
        cannelorderid:'',
        reason:'',
        cannelDialog:false,
        cannelLoading: false,
    }
  },
  
  mounted(){
    this.getactionauth();
    this.getorderlists();
  },
  
  methods:{

    //取消订单
    cannelGoods(obj) {

        this.$confirm('温馨提示：该操作会将订单取消，是否继续 ?', '提示', { type: 'warning' }).then(() => {
            this.cannelorderid=obj.id;
            this.reason='';
            this.cannelDialog=true;

        }).catch(() => {
            
        });

    },
    //确认取消订单
    cannelSave() {
        this.cannelLoading=true;
        var resource = this.$resource(this.url);
        resource.save({ 
            act:'cannelorder',
            id: this.cannelorderid,
            reason:this.reason,
            token:this.$cookies.get('token')}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.cannelLoading=false;
                }else{
                    this.$message.success('取消订单成功!');
                    this.cannelLoading=false;
                    this.cannelDialog=false;
                    this.searchorder();
                }
        }).catch((res) => {
            
        });
    },
    /** 查看操作日志 **/
    checklogs(item) {
        this.logDialog=true;
        this.logloading=true;
        this.loginfos=[];
        var resource = this.$resource(this.url);
        resource.save({ act:'getorderlogs',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.logloading=false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
				this.loginfos=result;
                this.logloading=false;
            }
        }).catch((res) => {
            this.logloading=false;
        });
    },

    /** 批处理订单信息 **/
    handleordermore(type) {
        if(type==1) this.verifyordermore(); //批审核订单
        if(type==2) this.verifyordercannelmore(); //订单批量反审核
    },

    /** 单个订单进行审核处理 **/
    gotoverify(item) {
        var _this=this;
        this.temporderlists=[];
        this.temporderlists.push({id:item.id,ordernumber:item.ordernumber});
        this.verifyorders.reason="";
        this.verifyorders.status=1;
        this.verifyorders.title="审核订单";
        this.verifyorders.type=3;
        this.verifyDialog=true;
    }, 

    /** 单个订单进行反审核处理 **/
    cannelverify(item) {
        var _this=this;
        this.temporderlists=[];
        this.temporderlists.push({id:item.id,ordernumber:item.ordernumber});
        this.verifyorders.reason="";
        this.verifyorders.status=1;
        this.verifyorders.title="反审核订单";
        this.verifyorders.type=4;
        this.verifyDialog=true;
    },

    /** 批处理反审核订单信息 **/
    verifyordercannelmore() {
        var _this=this;
        this.temporderlists=[];
        this.delgoodslists.forEach(function(item,index) {
            _this.temporderlists.push({id:item.id,ordernumber:item.ordernumber});
        });
        this.verifyorders.reason="";
        this.verifyorders.status=1;
        this.verifyorders.title="批量反审核订单";
        this.verifyorders.type=2;
        this.verifyDialog=true;
    },

    /** 批量审核订单 **/
    verifyordermore() {
        var _this=this;
        this.temporderlists=[];
        this.delgoodslists.forEach(function(item,index) {
            _this.temporderlists.push({id:item.id,ordernumber:item.ordernumber});
        });
        this.verifyorders.reason="";
        this.verifyorders.status=1;
        this.verifyorders.title="批量审核订单";
        this.verifyorders.type=1;
        this.verifyDialog=true;
    },


    /** 审核处理订单信息 **/
    saveverifyer() {
        var _this=this;
        this.verifyorders.ids=[];
        this.temporderlists.forEach(function(item,index) {_this.verifyorders.ids.push(item.id)});
        this.verifyorders.ids=this.verifyorders.ids.join(',');

        this.verifyorders.loading=true;
        var resource = this.$resource(this.url);		    
        resource.save(this.verifyorders).then((res) => {
            if(res.data.Result>0){
                this.verifyorders.loading=false;
                if(res.data.Result=='70001') this.$router.push('/login')

                var msg=res.data.Message;
                if(msg.status==1) this.$message.error(msg.data);
                if(msg.status==2) {
                    this.verifyDialog=false;
                    this.getorderlists();

                    var result = JSON.parse(msg.data);
                    this.errorshow=result;
                    this.errorshowDialog=true;
                }

            }else{
                this.verifyorders.loading=false;
                this.verifyDialog=false;
                this.getorderlists();
                if(this.verifyorders.type==1 || this.verifyorders.type==2) this.delgoodslists=[];
            }
        }).catch((res) => {
            this.verifyorders.loading=false;
        });
    },


    //删除目标订单
    deltemporders(index) {
        this.$delete(this.temporderlists,index);
    },

    //////////////////////////////////////////////////////////////////////////////////////////
    /** 勾选订单 **/
		goodsselectchange(val,row) {
      var ids=[];
      var number=-1;
      this.delgoodslists.forEach(function(item,index) {
          ids.push(item.id);
      });

			number=ids.indexOf(row.id);
			number==-1 ? this.delgoodslists.push(row) : this.$delete(this.delgoodslists,number);
		},

		/** 勾选/取消勾选全部订单 **/
		goodsallselectchange(val) {
        var _this=this;
        var number=-1;
        var ids=[];
        this.delgoodslists.forEach(function(item,index) {
            ids.push(item.id);
        });

        if(val.length > 0) { //新增商品
            val.forEach(function(item,i) {
                number=ids.indexOf(item.id);
                number==-1 ? _this.delgoodslists.push(item) : '';
            });

        }else { //删除订单
            this.lists.forEach(function(item,i) {
                number=ids.indexOf(item.id);
                if(number > -1) {
                    _this.$delete(ids,number);
                    _this.$delete(_this.delgoodslists,number);
                }
            });
        }
		},

		/** 清除已选中的订单信息 **/
		clearorderselect() {
			this.delgoodslists=[];
			this.getorderlists();
		},
    //////////////////////////////////////////////////////////////////////////


	/** 获取功能权限 **/
    getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 获取线上商城特批订单 **/
    getorderlists() {
        if(this.query.ischange) {
           this.query.p=1;
           this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);		    
        resource.query(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.query.ischange) this.query.ischange=false;

                var _this=this;
                var ids=[];
                this.delgoodslists.forEach(function(item,i) {ids.push(item.id)});
				setTimeout(function() {
					_this.lists.forEach(function(e,index){  
						ids.indexOf(e.id) >=0 ? _this.$refs.goodsmultipleTable.toggleRowSelection(e) : '';
					});
				},200);  
            }
        }).catch((res) => {
          this.query.loading=false;
        });
    },

    /** 下一页 **/
    orderpageSizeChange(val) {
  	  this.query.rollpage = val;
      this.getorderlists();
  	},

  	/** 下一页 **/
  	orderpageCurrentChange(val) {
  	    this.query.p = val;
        this.getorderlists();
  	},


     
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.cz-mall-order-verifys {display:flex;justify-content:left;align-items:center;margin-top:10px;width:calc(100% - 2px - 40px);padding:10px 20px;border-radius:6px;border:1px solid #fde2e2;background:#fef0f0;}
.cz-mall-order-verifys i {width:15px;height:15px;background:url(../../assets/gantanhao.png) no-repeat;background-size:15px 15px;background-position:center center;margin-right:10px;}
.cz-mall-order-verifys span {color:#f56c6c;font-size:12px;line-height:12px;}
.cz-mall-order-inputtime-center {float:left;width:100%;text-align:center;line-height:23px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.cz-mall-order-inputtime-center i {margin-left:5px;width:15px;height:15px;background:url(../../assets/wenhao.png) no-repeat;background-size:15px 15px;background-position:center center;}

.cz-mall-order-ready-title {display:inline-block;width:calc(100% - 10px);font-size:14px;color:#666666;font-weight:400;padding:5px 0 5px 10px;border-bottom:1px solid #EBEEF5;}
.cz-mall-order-ready-title i {font-style:normal;font-size:12px;color:#d81e06;margin-left:2%;font-weight:550;}
.cz-mall-order-ready-content {display:inline-block;width:100%;padding:20px 0;margin-bottom:10px;}
.cz-mall-order-ready-infos {float:left;font-size:13px;line-height:13px;padding:5px 30px 5px 10px;background:#fef0f0;border:1px solid #fbc4c4;border-radius:15px;color:#f56c6c;margin:0 10px 10px 0;position:relative;}
.cz-mall-order-ready-infos a {position:absolute;top:3px;right:3px;cursor:pointer;width:16px;height:16px;background-size:16px 16px !important;background-position:center center;background:url(../../assets/error.png) no-repeat;}

.cz-mall-order-ready-handle {display:inline-block;width:100%}
.cz-mall-order-ready-handle-title {float:left;padding-right:10px;font-size:13px;}
.cz-mall-order-ready-handle-content {float:left;margin-left:2%;}

.mall-order-refund-msg-more-result-out-verify {display:inline-block;width:100%}
.mall-order-refund-msg-more-result-verify {float:left;width:calc(100% - 4% - 2px );padding:5px 2%;display:flex;align-items:center;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;margin-bottom:10px}
.mall-order-refund-msg-more-result-verify img {width:20px;height:20px;border-radius:50%}
.mall-order-refund-msg-more-result-content-verify {float:left;font-size:13px;margin-left:10px}

.mall-order-sale-after-log-out-verify {display:inline-block;width:90%;padding:0 5%;}
.mall-order-sale-after-log-in-verify {float:left;width:calc(95% - 1px);padding:0 0 20px 5%;border-left:1px solid #dddddd;position:relative}
.mall-order-sale-after-log-in-label-verify {position:absolute;width:15px;height:15px;background:rgba(221,221,221);border-radius:50%;left:0;top:0;margin:-7.5px 0 0 -7.5px;display:flex;justify-content:center;align-items:center}
.mall-order-sale-after-log-in-label-in-verify {width:12px;height:12px;border-radius:50%;background:rgba(221,221,221)}
.mall-order-sale-after-log-in-msg-verify {float:left;font-size:12px;line-height:24px;width:100%}

</style>


// WEBPACK FOOTER //
// src/components/mall/Orderverify.vue